import { render, staticRenderFns } from "./twoDetail.vue?vue&type=template&id=09807577&scoped=true"
import script from "./twoDetail.vue?vue&type=script&lang=js"
export * from "./twoDetail.vue?vue&type=script&lang=js"
import style0 from "./twoDetail.vue?vue&type=style&index=0&id=09807577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09807577",
  null
  
)

export default component.exports